import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

export interface ApiTokenInfo {
  tokenPrefix: string;
  createdAt: string;
  lastUsedAt: string | null;
}

/**
 * Manages the company's external-API Bearer token (/api/external/v1/*),
 * generated/revoked from the "Subscription" tab in My Account.
 * See gt-api CompanyController.{getApiTokenInfo,generateApiToken,revokeApiToken}.
 */
@Injectable({
  providedIn: 'root',
})
export class ApiTokenService {
  private http = inject(HttpClient);

  private url(companyId: string) {
    return `${environment.apiUrl}/company/${companyId}/api-token`;
  }

  getTokenInfo(companyId: string) {
    return this.http.get<{ token: ApiTokenInfo | null }>(this.url(companyId));
  }

  /** Returns the raw token — the only time the backend ever sends it. */
  generateToken(companyId: string) {
    return this.http.post<{ token: string }>(this.url(companyId), {});
  }

  revokeToken(companyId: string) {
    return this.http.delete<void>(this.url(companyId));
  }

  getUsage(companyId: string) {
    return this.http.get<{ used: number; limit: number }>(
      `${environment.apiUrl}/company/${companyId}/api-usage`,
    );
  }
}
